import { render } from "./Mural.vue?vue&type=template&id=861b933a"
import script from "./Mural.vue?vue&type=script&lang=js"
export * from "./Mural.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__